import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PostEventRecording = function () {
  return <Space size='small' orientation='vertical'>
    <p>Recording post-event email templates</p>
    <EmailTemplateButton
      type='Post-event - Hands-on'
      title='Recording post event email template'
      settingKey='post-session.recording.closure' />
  </Space>
}

export default PostEventRecording
